const mutations = {
  // root
  CLEAR_STATE: 'CLEAR_STATE',
  POP_STATE: 'POP_STATE',
  SET_TOKEN: 'SET_TOKEN',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_TOKEN_ATTRS: 'SET_TOKEN_ATTRS',
  SET_ACCOUNT: 'SET_ACCOUNT',
  SET_MY_ROLE_INFO: 'SET_MY_ROLE_INFO',
  SET_ACCOUNT_ADDRESS: 'SET_ACCOUNT_ADDRESS',
  SET_ACCOUNT_ID: 'SET_ACCOUNT_ID',
  SET_LOGOUT_TIME: 'SET_LOGOUT_TIME',
}

const actions = {
  // root
  LOG_OUT: 'LOG_OUT',
  LOAD_ACCOUNT: 'LOAD_ACCOUNT',
  LOAD_MY_ROLE_INFO: 'LOAD_MY_ROLE_INFO',
  ENCODE_TOKEN: 'ENCODE_TOKEN',
  INIT_LOGOUT: 'INIT_LOGOUT',
}

const getters = {
  // root
  isLoggedIn: 'isLoggedIn',
  token: 'token',
  authToken: 'authToken',
  tokenAttrs: 'tokenAttrs',
  logoutTime: 'logoutTime',

  // account
  account: 'account',
  myRoleInfo: 'myRoleInfo',
  accountAddress: 'accountAddress',
  accountId: 'accountId',
  isAdminAccount: 'isAdminAccount',
}

export const vuexTypes = {
  ...mutations,
  ...actions,
  ...getters,
}
